import { ALERT_TYPES, ALERT_TYPES_NAMES } from '../constants/alertTypes';

export function getAlertName(alertTypeId) {
  return ALERT_TYPES_NAMES[alertTypeId - 1];
}

export function getAlertTypeID(alertName) {
  return ALERT_TYPES[alertName];
}
